// extracted by mini-css-extract-plugin
module.exports = {"project__used__item":"SkillBox_project__used__item__Uy_NO"};